import React, { useEffect } from 'react'
import { Typography } from '@material-ui/core'
import { AgentInfoForm } from 'src/app/components/forms'
import { useSelector } from 'react-redux'
import { RootState } from 'src/lib/store'
import { useHistory } from 'react-router-dom'

export const AgentInfoPage: React.FC = () => {
  const history = useHistory()
  const payloadState = useSelector((state: RootState) => state.payload.data)

  useEffect(() => {
    if (payloadState.relationshipType === '') history.replace('/')
  }, [payloadState.relationshipType, history])

  return (
    <>
      <Typography variant="body1" className='mb-4'>
        If you are the consumer's authorized agent, SAFE retains the right to verify the legitimacy of that designation, and to identify both you and the consumer.
        <br /><br />
        To verify your authorization to a make a request on behalf of the consumer, attach a copy of one of the following: power of attorney, court order documentation, or written permission from the consumer.
      </Typography>

      <AgentInfoForm />
    </>
  )
}
